/* Dovra — thema-scripts. Alles werkt ook zonder JavaScript; dit maakt het rustiger en sneller. */
(function () {
  'use strict';

  var B = window.Dovra || {};

  /* ---------- Geld ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || B.moneyFormat || '€{{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  B.formatMoney = formatMoney;

  /* ---------- Lades ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var toggle = document.querySelector('[aria-controls="' + drawer.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var toggle = document.querySelector('[aria-controls="' + drawer.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); return; }
    var cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && B.cartType === 'drawer' && document.getElementById('CartDrawer') && !document.querySelector('[data-cart-page]')) {
      e.preventDefault();
      openDrawer(document.getElementById('CartDrawer'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Header-schaduw ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------- Aankondigingsbalk ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, interval);
  });

  /* ---------- Rustig inschuiven ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }
  // In de thema-editor altijd alles tonen
  if (window.Shopify && window.Shopify.designMode) reveals.forEach(function (el) { el.classList.add('is-in'); });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });

  /* ---------- Galerij ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('.gallery__slide');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (slides.length < 2) return;
    var current = 0;
    slides.forEach(function (s, idx) { if (s.classList.contains('is-active')) current = idx; });
    var counter = gallery.querySelector('[data-gallery-counter]');
    function show(idx) {
      current = (idx + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    gallery.showMedia = function (mediaId) {
      slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(mediaId)) show(n); });
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var main = gallery.querySelector('.gallery__main');
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  });

  /* ---------- Product: varianten & aanbod ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var formId = section.getAttribute('data-form-id');
    var variantInputs = document.querySelectorAll('input[data-variant-input][form="' + formId + '"]');
    var offerInputs = document.querySelectorAll('input[data-offer-input][form="' + formId + '"]');
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var titleEl = section.querySelector('[data-variant-title]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var gallery = section.querySelector('[data-gallery]');

    function currentVariant() {
      var checked = Array.prototype.find.call(variantInputs, function (i) { return i.checked; });
      return checked || null;
    }

    function update() {
      var v = currentVariant();
      if (!v) return;
      var price = parseInt(v.getAttribute('data-price'), 10);
      var compare = parseInt(v.getAttribute('data-compare'), 10) || 0;
      var available = v.getAttribute('data-available') === 'true';
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (compareEl) {
        compareEl.hidden = !(compare > price);
        compareEl.textContent = formatMoney(compare);
      }
      if (titleEl) titleEl.textContent = v.getAttribute('data-title');
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? B.strings.addToCart : B.strings.soldOut;
      var onSale = compare > price;
      var priceWrap = section.querySelector('[data-price]');
      if (priceWrap) priceWrap.classList.toggle('price--sale', onSale);
      var badge = section.querySelector('[data-price-badge]');
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = B.strings.savePercent.replace('%p', Math.round((compare - price) * 100 / compare));
      }
      offerInputs.forEach(function (o) {
        var qty = parseInt(o.getAttribute('data-qty'), 10) || 1;
        var paid = parseInt(o.getAttribute('data-paid'), 10);
        if (isNaN(paid)) paid = qty;
        var unitCompare = Math.max(compare, price);
        var total = price * paid;
        var saving = unitCompare * qty - total;
        var box = o.closest('.choice');
        var p = box.querySelector('[data-offer-price]');
        var c = box.querySelector('[data-offer-compare]');
        var s = box.querySelector('[data-offer-save]');
        var each = box.querySelector('[data-offer-each]');
        if (p) p.textContent = formatMoney(total);
        if (c) { c.hidden = saving <= 0; c.textContent = formatMoney(unitCompare * qty); }
        if (s) { s.hidden = saving <= 0; s.textContent = B.strings.youSave.replace('%a', formatMoney(saving)); }
        if (each) each.textContent = B.strings.priceEach.replace('%p', formatMoney(Math.round(total / qty)));
      });
      var mediaId = v.getAttribute('data-media-id');
      if (mediaId && gallery && gallery.showMedia) gallery.showMedia(mediaId);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    variantInputs.forEach(function (i) { i.addEventListener('change', update); });

    // Vaste bestelknop op mobiel
    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          var btn = sticky.querySelector('button');
          if (btn) btn.tabIndex = past ? 0 : -1;
        });
      });
      stickyIO.observe(addBtn);
    }
  });

  /* ---------- Help & FAQ: zoeken en tellen ---------- */
  document.querySelectorAll('[data-help-center]').forEach(function (center) {
    var input = center.querySelector('[data-help-search]');
    var items = Array.prototype.slice.call(center.querySelectorAll('[data-help-item]'));
    var groups = Array.prototype.slice.call(center.querySelectorAll('[data-help-group]'));
    var empty = center.querySelector('[data-help-empty]');
    function counts() {
      groups.forEach(function (g) {
        var n = g.querySelectorAll('[data-help-item]:not([hidden])').length;
        var c = center.querySelector('[data-help-count="' + g.getAttribute('data-help-group') + '"]');
        if (c) c.textContent = n;
        g.hidden = n === 0;
      });
    }
    function filter(q) {
      q = (q || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var match = !q || it.textContent.toLowerCase().indexOf(q) !== -1;
        it.hidden = !match;
        if (match) shown++;
        if (q && match) it.open = true; else if (!q) it.open = false;
      });
      if (empty) empty.hidden = shown !== 0;
      counts();
    }
    if (input) input.addEventListener('input', function () { filter(input.value); });
    center.querySelectorAll('[data-help-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () { input.value = chip.getAttribute('data-help-chip'); filter(input.value); input.focus(); });
    });
    counts();
  });

  /* ---------- Track your order ---------- */
  document.querySelectorAll('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = form.querySelector('input[name="number"]').value.trim();
      if (n) window.open(form.getAttribute('data-url') + encodeURIComponent(n), '_blank', 'noopener');
    });
  });

  /* ---------- Kaartenslider op mobiel: puntjes ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var dotsWrap = slider.querySelector('[data-slider-dots]');
      if (!track || !dotsWrap || slider.__slider) return;
      slider.__slider = true;
      var cards = track.children;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < cards.length; i++) dotsWrap.appendChild(document.createElement('span'));
      var dots = dotsWrap.children;
      function sync() {
        var idx = 0, best = Infinity;
        for (var n = 0; n < cards.length; n++) {
          var d = Math.abs(cards[n].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; idx = n; }
        }
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) idx = cards.length - 1;
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === idx);
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }
  initSliders(document);
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });

  /* ---------- Voor en na ---------- */
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var range = slider.querySelector('[data-ba-range]');
    if (!range) return;
    function set(v) { slider.style.setProperty('--pos', v + '%'); }
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
  });

  /* ---------- Verzendmoment: tijd tot de echte uiterste besteltijd ---------- */
  function initDispatch(root) {
  (root || document).querySelectorAll('[data-dispatch]').forEach(function (el) {
    if (el.__dispatch) return;
    el.__dispatch = true;
    var textEl = el.querySelector('[data-dispatch-text]');
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var offset = parseInt(el.getAttribute('data-tz'), 10) || 0;
    var tzName = el.getAttribute('data-tzname');
    var days = (el.getAttribute('data-days') || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
    var lang = document.documentElement.lang || 'en';
    function storeNow() {
      var n = new Date();
      if (tzName) {
        try {
          var p = {};
          new Intl.DateTimeFormat('en-US', { timeZone: tzName, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
            .formatToParts(n).forEach(function (x) { p[x.type] = x.value; });
          return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
        } catch (err) { /* onbekende tijdzone: val terug op de vaste afwijking */ }
      }
      return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + offset * 3600000);
    }
    function isoDay(d) { var x = d.getDay(); return x === 0 ? 7 : x; }
    function render() {
      var now = storeNow();
      var minutesLeft = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
      if (days.indexOf(isoDay(now)) !== -1 && minutesLeft > 0) {
        var h = Math.floor(minutesLeft / 60), m = minutesLeft % 60;
        textEl.innerHTML = B.strings.dispatchToday.replace('%t', (h > 0 ? h + 'h ' : '') + m + 'm');
      } else {
        var next = new Date(now.getTime());
        for (var i = 0; i < 8; i++) { next.setDate(next.getDate() + 1); if (days.indexOf(isoDay(next)) !== -1) break; }
        var dayName = next.toLocaleDateString(lang, { weekday: 'long' });
        textEl.innerHTML = B.strings.dispatchNext.replace('%d', dayName);
      }
    }
    if (textEl && !isNaN(cutoff)) {
      render();
      var timer = setInterval(function () { if (!document.contains(el)) { clearInterval(timer); return; } render(); }, 30000);
    }
  });
  }
  initDispatch(document);

  /* ---------- Gratis verzending in een andere valuta (markten) ---------- */
  function initShipThreshold(root) {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : 1;
    if (!rate || rate === 1) return; /* winkelvaluta: Liquid klopt al */
    function threshold(el) { return Math.round(parseInt(el.getAttribute('data-base'), 10) * rate); }
    function total(el) { return parseInt(el.getAttribute('data-total'), 10) || 0; }
    root = root || document;
    root.querySelectorAll('[data-ship-bar]').forEach(function (el) {
      var t = threshold(el), left = t - total(el);
      var text = el.querySelector('[data-ship-text]');
      var bar = el.querySelector('[data-ship-progress]');
      if (text) text.innerHTML = left > 0 ? el.getAttribute('data-tpl-left').replace('[amount]', formatMoney(left)) : el.getAttribute('data-tpl-done');
      if (bar) bar.style.width = (left > 0 ? Math.floor(total(el) * 100 / t) : 100) + '%';
    });
    root.querySelectorAll('[data-ship-row]').forEach(function (el) {
      var free = total(el) >= threshold(el);
      el.children[0].hidden = !free;
      el.children[1].hidden = free;
    });
    root.querySelectorAll('[data-ship-free]').forEach(function (el) {
      el.hidden = total(el) < threshold(el);
      var list = el.parentNode;
      list.hidden = !Array.prototype.some.call(list.children, function (li) { return !li.hidden; });
    });
  }
  initShipThreshold(document);

  /* ---------- Winkelmand ---------- */
  var drawer = document.getElementById('CartDrawer');

  function refreshDrawer(openAfter) {
    return fetch((B.routes.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-panel]');
        var old = drawer.querySelector('[data-cart-panel]');
        if (fresh && old) old.innerHTML = fresh.innerHTML;
        initDispatch(drawer);
        initShipThreshold(drawer);
        if (openAfter) openDrawer(drawer);
      });
  }

  function updateCount() {
    return fetch((B.routes.cart || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (B.cartType !== 'drawer' || !drawer) return;
    if (form.closest('[data-cart-page]')) return; /* op de cartpagina gewoon herladen */
    e.preventDefault();
    var buttons = document.querySelectorAll('button[form="' + form.id + '"], form#' + CSS.escape(form.id || 'none') + ' button[type="submit"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-form-status]');
    if (submitBtn) submitBtn.classList.add('is-loading');
    var body = new FormData(form);
    fetch((B.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || B.strings.error);
        if (status) status.textContent = '';
        return Promise.all([updateCount(), refreshDrawer(true)]);
      })
      .catch(function (err) {
        if (status) status.textContent = err.message || B.strings.error;
      })
      .finally(function () {
        if (submitBtn) submitBtn.classList.remove('is-loading');
        buttons.forEach(function (b) { b.classList.remove('is-loading'); });
      });
  });

  function changeLine(line, quantity) {
    var panel = drawer.querySelector('[data-cart-panel]');
    if (panel.classList.contains('is-busy')) return;
    panel.classList.add('is-busy');
    return fetch((B.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10) || 0) })
    })
      .then(function () { return Promise.all([updateCount(), refreshDrawer(false)]); })
      .catch(function () { return refreshDrawer(false); })
      .finally(function () { panel.classList.remove('is-busy'); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      changeLine(btn.getAttribute('data-line'), btn.getAttribute('data-qty-change'));
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input) changeLine(input.getAttribute('data-line'), input.value);
    });
  }

  /* Cart-pagina: aantallen direct bijwerken */
  document.querySelectorAll('[data-cart-page] [data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      input.form.submit();
    });
  });
  document.querySelectorAll('[data-cart-page] input[name="updates[]"]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
})();
